/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { service } from "@ember/service";
import type { ValidatorMap } from "ember-changeset/types";
import type IntlService from "ember-intl/services/intl";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import DiabetowiseDischargeCompletedJournalEvent from "parog-web/models/diabetowise-discharge-completed-journal-event";

export default class DiabetowiseDischargeEditionFormComponent extends CrudJournalEventBaseComponent<DiabetowiseDischargeCompletedJournalEvent> {
  @service declare intl: IntlService;

  static forcDisplayedName = "Fiche de sortie";
  static fullComponentId = "diabetowise-discharge/edition-form";
  static journalEventClass = DiabetowiseDischargeCompletedJournalEvent;

  journalEventProperties = [
    "lastName",
    "firstName",
    "age",
    "gender",
    "prognosticLifeThreatening",
    "smoker",
    "weight",
    "height",
    "doSport",
    "phone",
    "met",
    "isglt2",
    "arglp1",
    "insulin",
    "idpp4",
    "hba1c",
    "hypoglycaemia",
    "severeHypoglycaemia",
    "hyperglycaemia",
    "severeHyperglycaemia",
    "hospitalisation",
    "neuropathie",
    "chronicRenalFailure",
    "dfg",
    "albuminuria",
    "rac",
    "mcva",
    "heartFailure",
    "fevg",
    "severeComorbidity",
    "hta",
    "systolic",
    "diastolic",
    "dyslipidemia",
    "comments",
    "occurredAt"
  ];

  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;

  get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  get initialModel() {
    return {
      lastName: this.patient.lastName,
      firstName: this.patient.firstName,
      age: this.patient.age,
      gender: this.patient.gender,
      height:
        this.patient.lastHeightMeasuredJournalEvent?.height ||
        this.patient.medicalHistoryChangedJournalEvent?.height,
      phone: this.patient.phone,
      met: this.patient.medicalHistoryChangedJournalEvent?.met,
      isglt2: this.patient.medicalHistoryChangedJournalEvent?.isglt2,
      arglp1: this.patient.medicalHistoryChangedJournalEvent?.arglp1,
      insulin: this.patient.medicalHistoryChangedJournalEvent?.insulin,
      idpp4: this.patient.medicalHistoryChangedJournalEvent?.idpp4
    };
  }
}
